<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/user-management.vue'
import { httpServices } from '@utils/http-services'
import { colorArr } from '@utils/style.const'
import { hasErrors } from '@utils/form'

export default {
  page: {
    title: 'Create Group',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      hasErrors,
      users: null,
      show: false,
      colors: colorArr.sort(),
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
    }
  },
  mounted() {
    httpServices.getUsers().then((res) => {
      this.users = res
    })
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = {
            orgId: this.$auth.user.profile.permissions.organization,
            groupId: values.name,
            meta: {
              color: values.color,
              userId: values.userId || [],
              orgId: this.$auth.user.profile.permissions.organization,
            },
          }
          httpServices.createGroup(data).then(
            () => {
              this.$notification.success({
                message: `Successfully Created User Group: ${data.groupId}`,
              })
              this.$router.push({
                name: 'user-management',
              })
            },
            () => {
              this.$notification.error({
                message: `Failed to Create User Group: That Group ID already exists.`,
              })
            }
          )
        }
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="ant-row profile--container">
      <div class="breadcrumb--container">
        <a-breadcrumb>
          <a-breadcrumb-item href="#">
            <router-link to="/">
              <a-icon type="home" />
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="#">
            <router-link to="/user-management">
              <a-icon type="team" />
              <span>User Management</span>
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <a-icon type="plus-square" />
            Add New User Group
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="form-container">
        <div
          class="header"
          style="
            padding: 1.2rem;
            margin-bottom: 0;
            text-align: center;
            background: #141414;
            border-radius: 4px 4px 0 0;
          "
        >
          <h4 style="margin: 0; font-weight: 100; color: #fff">
            <a-icon type="plus-square" style="padding-right: 4px" />
            Add New User Group
          </h4>
        </div>

        <template>
          <a-form :form="form" @submit="handleSubmit">
            <a-card>
              <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="Group Meta Data">
                  <a-card style="width: 100%">
                    <a-row>
                      <a-col :sm="16" :md="6">
                        <a-form-item label="Name">
                          <a-input
                            v-decorator="[
                              'name',
                              {
                                rules: [
                                  {
                                    required: true,
                                    placeholder:
                                      'Please input your group name!',
                                  },
                                ],
                              },
                            ]"
                            :placeholder="this.$route.params.groupId"
                          />
                        </a-form-item>
                      </a-col>
                      <a-col :sm="16" :md="6">
                        <a-form-item label="Color">
                          <a-select
                            v-decorator="[
                              'color',
                              {
                                required: true,
                              },
                            ]"
                          >
                            <a-select-option
                              v-for="(c, i) in colors"
                              :key="i"
                              :value="c.toLowerCase()"
                            >
                              {{ c }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="12">
                        <a-form-item label="Users">
                          <a-select v-decorator="['userId']" mode="multiple">
                            <a-select-option
                              v-for="user in users"
                              :key="user.key"
                              :value="user.pk"
                            >
                              {{ user.pk.replace('USER#', '') }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </a-card>
                </a-tab-pane>
              </a-tabs>

              <a-row class="submit--container">
                <a-col :sm="16" :md="8">
                  <a-form-item>
                    <a-button
                      type="primary"
                      html-type="submit"
                      :disabled="hasErrors(form.getFieldsError())"
                    >
                      Save
                    </a-button>
                  </a-form-item>
                </a-col>
                <a-col :sm="16" :md="8">
                  <a-form-item>
                    <a-button @click="$router.go(-1)"> Cancel </a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-card>
          </a-form>
        </template>
      </div>
    </div>
  </Layout>
</template>
